import React from 'react';
import {
  Button,
  Column,
  DatePicker,
  Dialog,
  DropMenu,
  DropMenuTrigger,
  OverlayTrigger,
  PageBar,
  PopOver,
  Select,
  Table,
} from '@tencent/spaui';

import { RPCFactory } from '../../../utils/RequestUtil';
import { PageUtil } from '../../../utils/PageUtil';
import moment from 'moment';
import { Tags } from '../../../consts/Tags';
import { leadsScoreTips } from '../../../consts/Tips';
import { Common, LeadsDataFilterShortcut } from '../../../consts/Common';
import CallRecordPage from '../leadsmanage/CallRecordPage';
import { ChatChart } from './chatChart';
import { judgeIsFromTMC } from '../../../utils';


const pageSizeList = [5, 10, 20];
const batchOperateTypeData = [
  {
    name: 'ctl',
    title: '',
    list: [
      {
        label: '会话评分',
        value: 2,
      },
    ],
  },
];

export default class ComponentReportPage extends React.Component {
  constructor(props) {
    super(props);
    const isFromXunda = PageUtil.getParaValue('from') === 'xd';
    this.state = {
      show: false,
      value: 'two',
      data: [], // 会话详情的数据列表
      detailPerson: {
        name: '',
        tel: '',
        wechat: '',
      },
      detailMessage: [],
      series: [
        {
          consultDate: '',
          consultNum: '',
        },
      ],
      showCallConfirmDialog: false,
      actionSubType: '',
      leadsSourceRelation: isFromXunda ? 9 : '',

      // 表格
      tableColumnChecks: [],

      // 表格编辑
      leadsScoreDialog: { show: false, disable: false },

      // 会话详情
      showCallRecord: false,
      leadsId: 0,
      pageIndex: 1,
      pageSize: 10,
      totalSize: 1,
      scoreTag: leadsScoreTips.intentionScoreTag,
      startActionDate: moment(Date.now() - 6 * 24 * 3600 * 1000).format('YYYY-MM-DD'),
      endActionDate: moment().format('YYYY-MM-DD'),
    };
    this.leadsId = '';
    this.getChartProps({
      series: this.state.series,
      startActionDate: this.state.startActionDate,
      endActionDate: this.state.endActionDate,
    });

    this.handleDateChange = this.handleDateChange.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleClose = this.handleClose.bind(this);

    this.dateShortcuts = LeadsDataFilterShortcut;
  }

  componentDidMount() {
    this.getConsultEffectList(); // 获取有效列表
    this.getConsultStatList(); // 获取有效会话趋势图
    this.checkIsInCarScoreWhiteList();
  }
  DateDifference(Date1, Date2) {
    return Math.abs(new Date(Date1).getTime() - new Date(Date2).getTime()) / 1000 / 60 / 60 / 24;
  }
  checkIsInCarScoreWhiteList = () => {
    RPCFactory.account.check_whitelist(window.pageProps.uid, 'auto.intention.score.whiteList').done((data) => {
      if (data) {
        this.setState({ scoreTag: leadsScoreTips.carScoreTag });
      }
    });
  };
  getConsultEffectList() {
    const { pageIndex, pageSize } = this.state;
    RPCFactory.componentReport
      .getConsultEffectList(
        this.state.actionSubType,
        this.state.leadsSourceRelation,
        this.state.startActionDate,
        this.state.endActionDate,
        pageSize,
        pageIndex,
      )
      .done((data) => {
        this.setState({
          data: data.entities,
          totalSize: data.size,
        });
      })
      .fail((code, msg) => {
        window.alert(`获取会话列表失败，失败信息：${msg}`);
        this.props.onCancel && this.props.onCancel();
      });
  }
  getConsultStatList() {
    this.setState({
      series: [],
    });
    RPCFactory.componentReport
      .getConsultStatList(
        this.state.startActionDate,
        this.state.endActionDate,
        this.state.actionSubType,
        this.state.leadsSourceRelation,
      )
      .done((data) => {
        this.setState({
          series: data.entities,
        });
        this.getChartProps({
          series: data.entities,
          startActionDate: this.state.startActionDate,
          endActionDate: this.state.endActionDate,
        });
      })
      .fail((code, msg) => {
        window.alert(`获取会话数目曲线表失败，失败信息：${msg}`);
        this.props.onCancel && this.props.onCancel();
      });
  }

  handleDateChange(event, startActionDate, endActionDate) {
    this.setState({ startActionDate, endActionDate }, () => {
      this.getConsultEffectList();
      this.getConsultStatList();
    });
  }

  /**
   * 页码点击
   * @param event
   * @param value
   */
  onChangePageIndex = (event, value) => {
    this.setState({ pageIndex: value }, () => {
      this.getConsultEffectList();
    });
  };

  /**
   * 页面条目数量点击
   * @param event
   * @param value
   */
  onChangePageSize = (event, value) => {
    this.setState({ pageSize: value, pageIndex: 1 }, () => {
      this.getConsultEffectList();
    });
  };

  handleChange(event, value) {
    this.setState({
      value,
    });
  }

  handleClose(event) {
    this.setState({
      showCallRecord: false,
    });
  }

  renderWordName = (type, name, value, data) => {
    const popover = (
      <PopOver>
        <span>用户消息数/客服消息数</span>
      </PopOver>
    );
    if (type == 'head') {
      return (
        <div>
          {value}
          <OverlayTrigger trigger="hover" delay={100} overlay={popover}>
            <i className="icon icon-help">
              <i></i>
            </i>
          </OverlayTrigger>
        </div>
      );
    }
    return `${data.customerMsgNum || ''}/${data.staffMsgNum || ''}`;
  };

  renderChatMarkTags = (type, name, value, data) => {
    if (type == 'head') {
      return value;
    }
    const afterConvert = value ? value.split(';').join(',') : '';
    return <div>{afterConvert}</div>;
  };

  renderIntentionScoreTagName = (type, name, value, data) => {
    if (type == 'head') {
      return <div>{value}</div>;
    }
    return <span>{value}</span>;
  };

  renderKfMessage = (type, name, value, data) => {
    if (type == 'head') {
      return <div>{value}</div>;
    }
    return (
      <div>
        姓名: {data.name}
        <br />
        电话: {data.tel}
        <br />
        微信: {data.wechat}
        <br />Q Q: {data.qq}
        <br />
        邮箱: {data.email}
      </div>
    );
  };

  renderCampainId = (type, name, value, data) => {
    if (type == 'head') {
      return value;
    }

    let completeValue;
    if (!value || value == '0') {
      completeValue = '';
    } else {
      completeValue = data.campaignName ? data.campaignName.concat('(', value, ')') : value;
    }

    let showText;
    if (completeValue && completeValue.length > 15) {
      showText = `${completeValue.substr(0, 15)}...`;
    } else {
      showText = completeValue;
    }
    return <div title={completeValue}>{showText}</div>;
  };

  renderAdId = (type, name, value, data) => {
    if (type == 'head') {
      return value;
    }

    let completeValue;
    if (!value || value == '0') {
      completeValue = '';
    } else {
      completeValue = data.adName ? data.adName.concat('(', value, ')') : value;
    }
    let showText;
    if (completeValue && completeValue.length > 15) {
      showText = `${completeValue.substr(0, 15)}...`;
    } else {
      showText = completeValue;
    }
    return <div title={completeValue}>{showText}</div>;
  };

  renderOperate = (type, name, value, data) => {
    if (type == 'head') {
      return value;
    }

    return (
      <div>
        <a
          href={'javascript:;'}
          onClick={(e) => {
            this.setState({
              showCallRecord: true,
              leadsId: data.leadsId,
            });
          }}
        >
          查看
        </a>
      </div>
    );
  };

  /**
   * =====================================================================
   * 外呼部分
   */
  showCallDialog = (event, callee, leadsId) => {
    if (!callee) {
      alert('被叫号码不能为空');
      return;
    }
    if (judgeIsFromTMC()) {
      top.postMessage({
        type: 'showCallDialog', data: {
          showCallConfirmDialog: true,
          callee,
          calleeLeadsId: leadsId,
        }
      }, '*')
    } else {
      this.setState({
        showCallConfirmDialog: true,
        callee,
        calleeLeadsId: leadsId,
      });
    }
  };

  onCancelCall = (event) => {
    this.setState({ showCallConfirmDialog: false });
  };

  onSubmitCall = (event) => {
    RPCFactory.call
      .call(window.pageProps.uid, this.state.callee, this.state.calleeLeadsId)
      .done((data) => {
        this.onCancelCall({});
      })
      .fail((ret, msg) => {
        alert(msg);
      });
  };

  leadsSourceRelation = {
    onChange: (event, value) => {
      this.setState({ leadsSourceRelation: value, pageIndex: 1 }, () => {
        this.getConsultEffectList();
        this.getConsultStatList();
      });
    },
    onClear: () => {
      this.setState({ leadsSourceRelation: '', pageIndex: 1 }, () => {
        this.getConsultEffectList();
        this.getConsultStatList();
      });
    },
  };

  actionSubType = {
    onChange: (event, value) => {
      this.setState({ actionSubType: value, pageIndex: 1 }, () => {
        this.getConsultEffectList();
        this.getConsultStatList();
      });
    },
    onClear: () => {
      this.setState({ actionSubType: '', pageIndex: 1 }, () => {
        this.getConsultEffectList();
        this.getConsultStatList();
      });
    },
  };

  showBatchOperateDialog = (e, data) => {
    const { tableColumnChecks } = this.state;
    if (tableColumnChecks.length == 0) {
      window.alert('请选择需要分配的线索');
      return;
    }
    if (data.ctl === 2) {
      if (
        window.pageProps.operatorRole != 'OPERATOR_ROLE_LEADS_OBSERVER' &&
        window.pageProps.operatorRole != 'OPERATOR_ROLE_LEADS_SUPER_OBSERVER'
      ) {
        this.leadsScoreDialog.show(e.target);
      } else {
        window.alert('您无权限进行评分！');
      }
    }
  };

  // 会话评分
  leadsScoreDialog = {
    show: (target, value, leadsId) => {
      const { leadsScoreDialog } = this.state;
      leadsScoreDialog.eventTarget = target;
      leadsScoreDialog.eventTargetLeft = target.getBoundingClientRect().left;
      leadsScoreDialog.eventTargetTop = target.getBoundingClientRect().top;
      leadsScoreDialog.show = true;
      leadsScoreDialog.leadsId = leadsId;
      leadsScoreDialog.leadsIntentionScoreTag = value;
      this.setState({ leadsScoreDialog });
    },
    onClose: () => {
      const { leadsScoreDialog } = this.state;
      leadsScoreDialog.show = false;
      this.setState({ leadsScoreDialog });
    },
    onChange: (event, value) => {
      const { leadsScoreDialog } = this.state;
      leadsScoreDialog.leadsIntentionScoreTag = value;
      this.setState({ leadsScoreDialog });
    },
    onConfirm: () => {
      const { leadsScoreDialog, tableColumnChecks } = this.state;
      RPCFactory.leadsManage
        .updateLeadsIntentionTags(window.pageProps.uid, tableColumnChecks, leadsScoreDialog.leadsIntentionScoreTag)
        .done((data) => {
          leadsScoreDialog.disable = false;
          this.setState({ leadsScoreDialog });
          this.leadsScoreDialog.onClose();
          setTimeout(() => {
            this.getConsultEffectList();
          }, 1000);
        })
        .fail((status, msg) => {
          alert(`请求失败，msg:${msg}`);
          leadsScoreDialog.disable = false;
          this.setState({ leadsScoreDialog });
        });
    },
  };

  download_report() {
    window.location.href = `${Common.CONSULT_DOWNLOAD}?accountId=${window.pageProps.uid}&startActionDate=${this.state.startActionDate}&endActionDate=${this.state.endActionDate}&actionSubType=${this.state.actionSubType}&leadsSource=${this.state.leadsSourceRelation}`;
  }

  onTableOptionalChange = (event, value) => {
    this.setState({ tableColumnChecks: value });
  };

  actionSubTypeRender = (type, name, value, data) => {
    if (type != 'head') {
      const typeTags = Object.assign({ 6: '智能咨询' }, { 1: '在线咨询' });
      return typeTags[value] ? typeTags[value] : '';
    }
    return value;
  };
  getChartProps = ({ series, startActionDate, endActionDate }) => {
    const pointStart = startActionDate;
    const pointEnd = endActionDate;
    const dateLength = this.DateDifference(pointStart, pointEnd);
    const pointData = new Array(dateLength + 1);

    pointData.fill(0);
    if (series.length > 0) {
      series.forEach((item) => {
        const length = this.DateDifference(pointStart, item.consultDate);
        pointData[length] = item.consultNum;
      });
    }
    const echart_props = {
      plotOptions: {
        series: {
          pointStart: new Date(pointStart).getTime(), // 开始值
          pointInterval: 24 * 3600 * 1000, // 间隔一天
        },
      },
      xAxis: {
        type: 'datetime',
        dateTimeLabelFormats: {
          day: '%Y-%m-%d',
        },
      },
      series: [
        {
          name: '会话',
          data: pointData,
        },
      ],
    };
    if (this.state.echart_props) {
      this.setState({ echart_props });
    } else {
      this.state.echart_props = echart_props;
    }
  };
  render() {
    const leadsIntentionTags = [];
    Object.keys(Tags.leadsIntentionTag).forEach((key) => {
      leadsIntentionTags.push({ value: key, label: Tags.leadsIntentionTag[key] });
    });

    const { value, show, pageIndex, pageSize, totalSize } = this.state;

    // 线索类型 //{value: 1, label: Tags.actionSubTypeTag[1]},  //
    const actionSubTypeIds = [{ value: 1, label: '在线咨询' }, { value: 6, label: '智能咨询' }];

    // 线索来源
    const leadsSourceIds = [
      { value: 4, label: Tags.leadsSourceTag[4] },
      { value: 5, label: Tags.leadsSourceTag[5] },
      { value: 8, label: Tags.leadsSourceTag[8] },
      { value: 9, label: Tags.leadsSourceTag[9] },
    ];
    return (
      <div className="main">
        <div className="page-comreport">
          <div className="card">
            <div className="datarea">
              <div className="toolbars">
                <div className="toolbar table-toolbar">
                  <div className="toolbar-left">
                    <h4>
                      <span className="">会话时间</span>
                    </h4>
                  </div>
                  <div className="toolbar-right clearfix">
                    <DatePicker
                      className={'form-group'}
                      type="range"
                      startDate={this.state.startActionDate}
                      endDate={this.state.endActionDate}
                      onChange={this.handleDateChange}
                      shortcuts={this.dateShortcuts}
                      useShortcut
                    />
                    <div className="inquire-con">
                      <Select
                        placeholder="请选择线索类型"
                        clear
                        data={actionSubTypeIds}
                        value={this.state.actionSubType}
                        onChange={this.actionSubType.onChange}
                        onClear={this.actionSubType.onClear}
                      />
                    </div>
                    <div className="inquire-con">
                      <Select
                        placeholder="请选择线索来源"
                        clear
                        data={leadsSourceIds}
                        value={this.state.leadsSourceRelation}
                        onChange={this.leadsSourceRelation.onChange}
                        onClear={this.leadsSourceRelation.onClear}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <ChatChart echart_props={this.state.echart_props}></ChatChart>
              <div className="toolbars">
                <div className="toolbar table-toolbar">
                  <div className="toolbar-left">
                    <h4>
                      <span className="">会话详情</span>
                    </h4>
                  </div>
                  <div className="toolbar-right">
                    <div className="toolbar-right-group">
                      <DropMenuTrigger
                        documentClickAutoHide={false}
                        dropMenu={<DropMenu onChange={this.showBatchOperateDialog} data={batchOperateTypeData} />}
                      >
                        <Button className="borderless">
                          <i className="icon icon-batch"></i>批量操作
                        </Button>
                      </DropMenuTrigger>
                      <Button className="borderless">
                        <i className="icon icon-download"></i>
                        <span onClick={this.download_report.bind(this)} className="spaui-text">
                          下载数据
                        </span>
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="datalist">
                <Table data={this.state.data}>
                  <Column
                    fixedable
                    type="optional"
                    target="leadsId"
                    multiple
                    value={this.state.tableColumnChecks}
                    onOptionalChange={this.onTableOptionalChange}
                  ></Column>
                  <Column name="leadsId" show={false}>
                    线索ID
                  </Column>
                  <Column name="actionSubType" render={this.actionSubTypeRender}>
                    线索类型
                  </Column>
                  <Column name="leadsSourceName">线索来源</Column>
                  <Column name="consultBeginTime">会话开始时间</Column>
                  <Column render={this.renderWordName} name="cWordCount">
                    会话数
                  </Column>
                  <Column render={this.renderIntentionScoreTagName} name="intentionScoreTagName">
                    会话评分
                  </Column>
                  <Column render={this.renderChatMarkTags} name="chatMarkTags">
                    会话标签
                  </Column>
                  <Column render={this.renderKfMessage} name="name">
                    用户信息
                  </Column>
                  <Column name="accountId">推广账户ID</Column>
                  <Column render={this.renderCampainId} name="campaignId">
                    推广计划
                  </Column>
                  <Column render={this.renderAdId} name="adId">
                    广告
                  </Column>
                  <Column name="consultUrl">咨询页URL</Column>
                  <Column name="clickId">点击ID</Column>
                  <Column name="consultToolName">咨询工具类型</Column>
                  <Column render={this.renderOperate} name="operate">
                    操作
                  </Column>
                </Table>

                <PageBar
                  value={pageIndex}
                  pageSize={pageSize}
                  totalSize={totalSize}
                  pageSizeList={pageSizeList}
                  onChange={this.onChangePageIndex}
                  onPageSizeChange={this.onChangePageSize}
                />
              </div>

              <Dialog
                eventTarget={this.state.leadsScoreDialog.eventTarget}
                style={{ width: '300px' }}
                eventTargetLeftDeviation={-70}
                eventTargetTopDeviation={-70}
                show={this.state.leadsScoreDialog.show}
                onClose={this.leadsScoreDialog.onClose}
                onSubmit={(e) => {
                  const { leadsScoreDialog } = this.state;
                  leadsScoreDialog.disable = true;
                  this.setState({ leadsScoreDialog }, () => {
                    this.leadsScoreDialog.onConfirm();
                  });
                }}
                onCancel={this.leadsScoreDialog.onClose}
                title="修改会话评分"
                className="modal-w300 modal-simple"
                disabled={this.state.leadsScoreDialog.disable}
              >
                <Select
                  placeholder="会话评分"
                  data={leadsIntentionTags}
                  value={this.state.leadsScoreDialog.leadsIntentionScoreTag}
                  onChange={this.leadsScoreDialog.onChange}
                  onClear={this.leadsScoreDialog.onClear}
                />
              </Dialog>

              <Dialog
                backdrop
                hideFooter
                type="normal"
                className="modal-max-height"
                title="会话记录"
                show={this.state.showCallRecord}
                onClose={this.handleClose}
                onSubmit={this.handleClose}
                onCancel={this.handleClose}
                style={{ width: '800px' }}
              >
                <CallRecordPage leadsId={this.state.leadsId} />
              </Dialog>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
